<template>
  <v-card class="ps-card" flat>
    <div class="ps-card__head">
      <v-icon small>mdi-package-variant-closed</v-icon>
      Product Types
      <v-spacer />
      <v-btn @click="showProductTypeDialog = true" color="primary" depressed small rounded>
        <v-icon small left>mdi-plus</v-icon>Product Type
      </v-btn>
    </div>
    <v-card-text>
      <v-data-table
        :loading="loadingProductTypes"
        :headers="headers"
        :items="productTypes"
        class="ps-table"
      >
        <template v-slot:item.name="{ item }">
          <span class="ps-name">{{ item.name }}</span>
        </template>
        <template v-slot:item.resultsInTask="{ item }">
          <v-icon small :class="item.resultsInTask ? 'ps-bool--yes' : 'ps-bool--no'">
            {{ item.resultsInTask ? "mdi-check-circle" : "mdi-close-circle-outline" }}
          </v-icon>
        </template>
        <template v-slot:item.isDigital="{ item }">
          <v-icon small :class="item.isDigital ? 'ps-bool--yes' : 'ps-bool--no'">
            {{ item.isDigital ? "mdi-check-circle" : "mdi-close-circle-outline" }}
          </v-icon>
        </template>
        <template v-slot:item.useTeeinblue="{ item }">
          <v-icon small :class="item.useTeeinblue ? 'ps-bool--yes' : 'ps-bool--no'">
            {{ item.useTeeinblue ? "mdi-check-circle" : "mdi-close-circle-outline" }}
          </v-icon>
        </template>
        <template v-slot:item.imagePropName="{ item }">
          <span v-for="cc in Object.keys(item.imagePropName)" :key="cc" class="ps-chip">
            {{ flag(cc) }} {{ cc }}
          </span>
        </template>
        <template v-slot:item.costs="{ item }">
          <span class="ps-price">{{ formatPrice(item.costs) }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="() => editProductType(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <AddProductTypeDialog
      :show="!!showProductTypeDialog"
      :on-close="
        () => {
          showProductTypeDialog = null;
        }
      "
      :product-type="productTypeToEdit"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddProductTypeDialog from "@/components/Settings/Products/ProductTypes/ProductTypeDialog";

export default {
  name: "ProductTypes",
  components: { AddProductTypeDialog },
  data() {
    return {
      showProductTypeDialog: null,
      productTypeToEdit: null,
      headers: [
        { text: "Product Type", value: "name" },
        { text: "Ergibt Task", value: "resultsInTask" },
        { text: "Digital", value: "isDigital" },
        { text: "Teeinblue", value: "useTeeinblue" },
        { text: "Länder", value: "imagePropName" },
        { text: "Kosten (geschätzt)", value: "costs" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    ...mapGetters(["productTypes", "loadingProductTypes"]),
  },
  mounted() {
    this.loadProductTypes();
  },
  methods: {
    ...mapActions(["loadProductTypes"]),
    flag(cc) {
      if (!/^[A-Z]{2}$/.test(cc)) return "";
      return String.fromCodePoint(
        ...[...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
      );
    },
    formatPrice(value) {
      const num = Number(value) || 0;
      return num.toFixed(2).replace(".", ",") + " €";
    },
    editProductType(productType) {
      this.productTypeToEdit = productType;
      this.showProductTypeDialog = true;
    },
  },
};
</script>

<style scoped></style>
